module.exports = __webpack_public_path__ + "static/media/cont19.5fa9dcb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont19.mp4
// module id = H+Tl
// module chunks = 0